// extracted by mini-css-extract-plugin
export default {"buttonText":"bouncyButton_buttonText__PrcA2","link":"bouncyButton_link__WU8c9","color":"bouncyButton_color__TxLka","svgContainer":"bouncyButton_svgContainer__PjeBN"};